import React from 'react';

import { isEmptyString } from 'Shared/helpers';
import { useToggle } from 'Shared/utils/hooks';

type Props = {
  text: string;
  fullText?: boolean;
  className?: string;
};

export default function Transcription({ text, fullText = false, className }: Props) {
  const [transcriptionExpanded, toggleTranscriptionExpanded] = useToggle(false);

  if (isEmptyString(text)) {
    return <p className={`small text-muted ${className}`}>No transcription</p>;
  }
  if (!text) {
    return <p className={`small text-muted ${className}`}>Transcribing...</p>;
  }
  if (text.length <= 120 || fullText) {
    return <p className={`small text-muted ${className}`}>{`Transcription: ${text}`}</p>;
  }

  return (
    <p className={`small text-muted ${className}`}>
      {`Transcription: ${transcriptionExpanded ? text : `${text.substring(0, 120)}...`} `}
      <button
        type="button"
        className="d-inline btn btn-link p-0"
        onClick={toggleTranscriptionExpanded}
        style={{ fontSize: '100%', verticalAlign: 'top', borderTop: 'none' }}
      >
        {transcriptionExpanded ? 'read less' : 'read more'}
      </button>
    </p>
  );
}
